var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisibilityOff = function SvgVisibilityOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    fillRule: "evenodd",
    d: "M19.587 3 2.62 19.615l-.002-.001-.002.001L4.03 21l3.357-3.287c1.257.574 2.78.952 4.614.952 7.592 0 9.874-6.48 9.896-6.545l.104-.31-.105-.309c-.014-.041-.929-2.642-3.515-4.552L21 4.383 19.587 3zM8.913 16.218l1.797-1.76c.392.186.83.29 1.29.29 1.642 0 3-1.33 3-2.937 0-.45-.107-.88-.296-1.263l2.26-2.213a8.407 8.407 0 0 1 2.92 3.476c-.5 1.13-2.562 4.896-7.884 4.896-1.184 0-2.207-.187-3.087-.49z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M14.5 5.212a11.91 11.91 0 0 0-2.5-.255c-7.592 0-9.874 6.479-9.896 6.544l-.104.31.105.31c.01.031.57 1.622 2.044 3.226l1.392-1.362a8.358 8.358 0 0 1-1.424-2.174c.499-1.13 2.56-4.896 7.883-4.896.252 0 .498.008.736.025L14.5 5.212z"
  })));
};
export default SvgVisibilityOff;